import { SxStyles } from '../../../../types';
import theme from '../../../../theme';
import { getResponsiveSize } from '../../../../utils';

export const colourDetailsStyles: SxStyles = {
  colourDetails: {
    display: 'flex',
    alignItems: 'end',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    mb: getResponsiveSize(24),

    '& .subtitle-container': {
      position: 'relative',
      right: '0%',
      display: 'flex',
      alignItems: 'center',
      '& .subtitle-text': {
        pl: getResponsiveSize(7),
        fontSize: theme.typography.fs13,
      },
      '& .MuiButtonBase-root': {
        color: theme.palette.mainControls?.mainBlue,
        p: 0,
        lineHeight: 'normal',
        '& .MuiSvgIcon-root': {
          fontSize: theme.typography.fs24,
        },
      },
    },

    '& .colors-container': {
      position: 'relative',
      display: 'grid',
      gridTemplateColumns: 'repeat(5, auto)',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      rowGap: getResponsiveSize(1),
      columnGap: getResponsiveSize(1),
      '& .balls': {
        p: 0.25,
        '& .MuiSvgIcon-root': {
          fontSize: getResponsiveSize(15),
        },
      },
      '& .color-picker': {
        color: theme.palette.neutral?.grey50,
        '& .MuiSvgIcon-root': {
          color: theme.palette.neutral?.grey50,
          fontSize: getResponsiveSize(15),
        },
      },
      '& .auto-colour-active': {
        opacity: 0.5,
        pointerEvents: 'none',
      },
    },
  },
};
